// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLayout_root__LC0Sx","contextMenu":"MenuLayout_contextMenu__MzHDg","defaultMenu":"MenuLayout_defaultMenu__mu2xb","label":"MenuLayout_label__5H_7_"};